const BASE_URL = "/gateway/mandates";

export const PAGE_URLS = {
  home: "/",
  list: BASE_URL,
  details: `${BASE_URL}/:id`,
  getLinkToDetails: (id: string) => `${BASE_URL}/${id}`,
  payments: `${BASE_URL}/:id/payments`,
  getLinkToPayments: (id: string) => `${BASE_URL}/${id}/payments`,
  notifications: `${BASE_URL}/:id/notifications`,
  getLinkToNotifications: (id: string) => `${BASE_URL}/${id}/notifications`,
} as const;
